export default {
  loading_menu: 'Caricamento menu...',
};
